module.exports = __webpack_public_path__ + "static/img/product01-2.aee95d84.png";